import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setSessionStorage } from '../util';
import { QUOTING_STORAGE } from '../constants';

const StorageProvider = () => {
  const store = useSelector((stores) => stores.quoting);

  useEffect(() => {
    if (store.data) {
      setSessionStorage({ data: store, key: QUOTING_STORAGE });
      setSessionStorage({ data: { isMounted: true }, key: 'store.mounted' });
    }
  }, [store]);

  return null;
};

export default StorageProvider;
